import { Component, OnInit, Self, Optional, Input, ViewChild, NgZone } from '@angular/core';
import { ControlValueAccessor, NgControl } from '@angular/forms';
import { InputField } from '../input-field';
import { CdkTextareaAutosize } from '@angular/cdk/text-field';
import { take } from 'rxjs/operators';

@Component({
  selector: 'file360-multi-line-text-field',
  templateUrl: './multi-line-text-field.component.html',
  styleUrls: ['./multi-line-text-field.component.scss']
})
export class MultiLineTextFieldComponent extends InputField implements ControlValueAccessor, OnInit {

  @ViewChild('autosize') autosize: CdkTextareaAutosize | undefined;

  /**
   * The minimum number of rows of the text area to display
   */
  @Input() minRows: number = 2;

  /**
   * The maximum number of rows of the text area to display
   */
  @Input() maxRows: number | undefined;

  /**
   * When in read-only mode, max height in rems
   */
  @Input() maxHeight: number | undefined;

  constructor(@Optional() @Self() public controlDir: NgControl, private ngZone: NgZone) {
    super();
    if (controlDir != null) {
      controlDir.valueAccessor = this;
    }
  }

  ngOnInit() {
    if (this.controlDir != null && this.controlDir.control != null && this.controlDir.control.validator) {
      this.field.setValidators(this.controlDir.control.validator);
      this.field.updateValueAndValidity();
    }
  }

  writeValue(value: any) {
    // Binding to textarea value in IE/Edge when value is null, displays the word null.
    // https://github.com/angular/angular/issues/14241
    if (value === null) {
      this.field.setValue("", { emitEvent: false });
    } else {
      this.field.setValue(value, { emitEvent: false });
    }
  }


  registerOnChange(fn: (value: any) => void) {
    this.onChange = fn;
  }

  registerOnTouched(fn: (value: any) => void) {
    this.onTouched = fn;
  }

  setDisabledState(disabled: boolean) {
    disabled ? this.field.disable() : this.field.enable();
  }

  triggerResize() {
    // Wait for changes to be applied, then trigger textarea resize.
    this.ngZone.onStable.pipe(take(1))
      .subscribe(() => {
        if (this.autosize != undefined) {
          this.autosize.resizeToFitContent(true);
        }
      });
  }
}